import { Component, CUSTOM_ELEMENTS_SCHEMA, Input } from '@angular/core';
import { PartsManagementResponse } from '../../../models/parts-management-response.model';

@Component({
  selector: 'app-parts-management-comments',
  imports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './parts-management-comments.component.html',
  styleUrl: './parts-management-comments.component.scss',
})
export class PartsManagementCommentsComponent {
  @Input() partsManagementComments!: PartsManagementResponse;
}
